import { render, staticRenderFns } from "./mydakalist.vue?vue&type=template&id=2b531f4c&"
import script from "./mydakalist.vue?vue&type=script&lang=js&"
export * from "./mydakalist.vue?vue&type=script&lang=js&"
import style0 from "./mydakalist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b531f4c')) {
      api.createRecord('2b531f4c', component.options)
    } else {
      api.reload('2b531f4c', component.options)
    }
    module.hot.accept("./mydakalist.vue?vue&type=template&id=2b531f4c&", function () {
      api.rerender('2b531f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/mydakalist.vue"
export default component.exports